export const EXPANDED_HOME_SIDEBAR_WIDTH = 280
export const EXPANDED_HOME_SIDEBAR_WIDTH_PX = `${EXPANDED_HOME_SIDEBAR_WIDTH}px`

export const COLLAPSED_HOME_SIDEBAR_WIDTH = 56
export const COLLAPSED_HOME_SIDEBAR_WIDTH_PX = `${COLLAPSED_HOME_SIDEBAR_WIDTH}px`

export const HOME_SIDEBAR_TRANSITION =
	'width 250ms ease-in-out, min-width 250ms ease-in-out, margin 250ms ease-in-out, padding 250ms ease-in-out, background-color 200ms'
